import React, { useState, useEffect } from 'react';
import { InputHandler, KeyCode, ControlScheme } from './InputHandler.ts';
import './ControlsIndicator.css';

interface ControlsIndicatorProps {
  pressedKeys: {
    KeyW: boolean;
    KeyA: boolean;
    KeyS: boolean;
    KeyD: boolean;
  };
  inputHandler: InputHandler | null;
}

const SCHEMES: Record<ControlScheme, { key: KeyCode; label: string }[]> = {
  wasd: [
    { key: 'KeyW', label: 'W' },
    { key: 'KeyA', label: 'A' },
    { key: 'KeyS', label: 'S' },
    { key: 'KeyD', label: 'D' },
  ],
  arrows: [
    { key: 'KeyW', label: '↑' },
    { key: 'KeyA', label: '←' },
    { key: 'KeyS', label: '↓' },
    { key: 'KeyD', label: '→' },
  ],
};

export const ControlsIndicator: React.FC<ControlsIndicatorProps> = ({ pressedKeys, inputHandler }) => {
  const [scheme, setScheme] = useState<ControlScheme>('wasd');

  useEffect(() => {
    if (!inputHandler) return;
    const poll = setInterval(() => {
      if (inputHandler.activeScheme !== scheme) {
        setScheme(inputHandler.activeScheme);
      }
    }, 100);
    return () => clearInterval(poll);
  }, [inputHandler, scheme]);

  const keys = SCHEMES[scheme];
  const positionClasses = ['ctrl-up', 'ctrl-left', 'ctrl-down', 'ctrl-right'];

  const handlePointerDown = (key: KeyCode) => (e: React.PointerEvent) => {
    e.preventDefault();
    (e.target as HTMLElement).setPointerCapture(e.pointerId);
    inputHandler?.pressKey(key);
  };

  const handlePointerUp = (key: KeyCode) => (e: React.PointerEvent) => {
    e.preventDefault();
    inputHandler?.releaseKey(key);
  };

  return (
    <div className="controls-indicator">
      <div className="controls-grid">
        {keys.map(({ key, label }, i) => (
          <div
            key={key}
            className={`ctrl-key ${positionClasses[i]} ${pressedKeys[key] ? 'pressed' : ''}`}
            onPointerDown={handlePointerDown(key)}
            onPointerUp={handlePointerUp(key)}
            onPointerCancel={handlePointerUp(key)}
          >
            {label}
          </div>
        ))}
        <div className="ctrl-spacer"></div>
        <div className="ctrl-spacer"></div>
      </div>
    </div>
  );
};
